


































































































import { Vue, Component } from "vue-property-decorator";
import { VerifyPatientsOptions } from "@/types";
import Table from "@/components/Table.vue";
import { verifyPatientModule } from "@/store/modules/verifyPatients";

@Component({
  components: {
    Table,
  },
})
export default class VerifyPatients extends Vue {
  public dialog = false;
  public dialogTitle = "";
  public headers = [
    {
      text: "名稱",
      left: true,
      sortable: false,
      value: "name",
    },
    { text: "身份證字號", sortable: true, value: "iid" },
    { text: "性別", sortable: false, value: "gender" },
    { text: "年齡", sortable: false, value: "age" },
    { text: "地區", sortable: true, value: "branchName"},
    { text: "生日", sortable: false, value: "birthday" },
    { text: "電話", sortable: false, value: "phone" },
    { text: "信箱", sortable: false, value: "email" },
  ];

  private verifyPatientOptions = {
    page: 1,
    q: "",
    order: "asc",
    sort: "",
    range: undefined,
    place: ""
  };
  private lastSearch = "";//andy

  public verifySelect: VerifyPatientsOptions = {
    // eslint-disable-next-line no-undef
    patients: [],
    status: true,
  };

  get loading() {
    return verifyPatientModule.loading;
  }

  get pagination(){
    return verifyPatientModule.pagination;
  }

  get verifyPatients(){
    return verifyPatientModule.verifyPatients;
  }

  get verifyItems(){
    return verifyPatientModule.verifyItems;
  }

  get currentPage(){
    return verifyPatientModule.currentPage;
  }

  get totalVerifyPatients(){
    return verifyPatientModule.totalVerifyPatients;
  }

  get totalPages(){
    return verifyPatientModule.totalPages;
  }

  created() {
    this.updateTableData();
  }


  showDialog(title) {
    this.dialog = true;
    this.dialogTitle = title;
    if (title == "不通過名單") {
      this.verifySelect.status = false;
    }
  }

  close() {
    this.dialog = false;
  }

  public async save() {
    this.dialog = false;
    await this.verifyPatientsByUuid(this.verifySelect);
    await this.updateTableData();
  }

  async updateTableData() {
    //andy
    if(this.verifyPatientOptions.q!== this.lastSearch){
      this.verifyPatientOptions.page = 1;
      this.lastSearch = this.verifyPatientOptions.q;
    }
    await verifyPatientModule.getVerifyPatients(this.verifyPatientOptions);
  }

  async verifyPatientsByUuid(
    verifySelects: VerifyPatientsOptions
  ): Promise<TODO> {
    const patients = verifySelects.patients;
    const params = {
      status: verifySelects.status,
    };
    for (const patient of patients) {
      const param = {
        uuid: patient.uuid,
        params: params
      }
      await verifyPatientModule.verifyPatientsByUuid(param);
    }
  }

  async destroyed() {
    verifyPatientModule.clearVerifyPatients();
  }
}
